if (!customElements.get('product-media-gallery-wub')) {
  class ProductMediaGalleryWub extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.slides = Array.from(this.querySelectorAll('[data-media-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb-button]'));
      this.bullets = Array.from(this.querySelectorAll('[data-bullet-button]'));
      this.prevButton = this.querySelector('[data-gallery-prev]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.viewport = this.querySelector('.wub-media-gallery__viewport');
      this.lightboxEnabled = this.dataset.lightboxEnabled === 'true';
      if (!this.slides.length) return;

      this.activeIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.mobileQuery = window.matchMedia('(max-width: 1067px)');
      this.scrollRaf = 0;
      this.bindEvents();
      this.bindResponsiveMode();
      this.goToIndex(this.activeIndex, false, false);
      this.queueNeighborPrewarm();
    }

    bindEvents() {
      this.thumbs.forEach((button) => button.addEventListener('click', () => this.activateByMediaId(button.dataset.mediaId, true, true)));
      this.bullets.forEach((button) => button.addEventListener('click', () => this.activateByMediaId(button.dataset.mediaId, false, true)));
      this.prevButton?.addEventListener('click', () => this.goToIndex(this.activeIndex - 1, true, true));
      this.nextButton?.addEventListener('click', () => this.goToIndex(this.activeIndex + 1, true, true));

      this.onProductState = (event) => {
        const detail = event.detail || {};
        if (String(detail.sectionId || '') !== String(this.dataset.sectionId || '')) return;
        const mediaId = detail.variant?.featuredMediaId ?? detail.variant?.featured_media?.id;
        if (mediaId) this.activateByMediaId(String(mediaId), false, false);
      };
      document.addEventListener('wub:product-state-change', this.onProductState);

      this.bindNativeSwipe();
      this.bindZoom();
    }

    bindResponsiveMode() {
      this.onMediaChange = () => this.configureSwipeMode();
      if (typeof this.mobileQuery.addEventListener === 'function') this.mobileQuery.addEventListener('change', this.onMediaChange);
      else if (typeof this.mobileQuery.addListener === 'function') this.mobileQuery.addListener(this.onMediaChange);

      this.onResize = () => {
        if (!this.isNativeSwipeMode() || !this.viewport) return;
        window.requestAnimationFrame(() => this.scrollViewportToIndex(this.activeIndex, 'auto'));
      };
      window.addEventListener('resize', this.onResize, { passive: true });
      this.configureSwipeMode();
    }

    configureSwipeMode() {
      const nativeSwipe = this.isNativeSwipeMode();
      this.dataset.nativeSwipeReady = nativeSwipe ? 'true' : 'false';

      this.slides.forEach((slide, index) => {
        if (nativeSwipe) slide.hidden = false;
        else slide.hidden = index !== this.activeIndex;
      });

      if (nativeSwipe && this.viewport) {
        window.requestAnimationFrame(() => this.scrollViewportToIndex(this.activeIndex, 'auto'));
      } else if (this.viewport) {
        this.viewport.scrollLeft = 0;
      }

      this.updateState(false, false);
    }

    isNativeSwipeMode() {
      return Boolean(this.mobileQuery?.matches);
    }

    bindNativeSwipe() {
      if (!this.viewport) return;
      this.onViewportScroll = () => {
        if (!this.isNativeSwipeMode() || this.scrollRaf) return;
        this.scrollRaf = window.requestAnimationFrame(() => {
          this.scrollRaf = 0;
          const width = this.viewport.clientWidth;
          if (!width) return;
          const index = Math.max(0, Math.min(Math.round(this.viewport.scrollLeft / width), this.slides.length - 1));
          if (index === this.activeIndex) return;
          this.activeIndex = index;
          this.updateState(false, false);
          this.prewarmAround(index);
        });
      };
      this.viewport.addEventListener('scroll', this.onViewportScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.onProductState) document.removeEventListener('wub:product-state-change', this.onProductState);
      if (this.viewport && this.onViewportScroll) this.viewport.removeEventListener('scroll', this.onViewportScroll);
      if (this.mobileQuery && this.onMediaChange) {
        if (typeof this.mobileQuery.removeEventListener === 'function') this.mobileQuery.removeEventListener('change', this.onMediaChange);
        else if (typeof this.mobileQuery.removeListener === 'function') this.mobileQuery.removeListener(this.onMediaChange);
      }
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
    }

    bindZoom() {
      if (!this.lightboxEnabled) return;
      this.querySelectorAll('[data-gallery-zoom]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;
          event.preventDefault();
          const currentSlide = event.currentTarget.closest('[data-media-slide]');
          const imageSlides = this.slides.filter((slide) => slide.querySelector('.wub-media-gallery__media img') && slide.querySelector('[data-gallery-zoom]'));
          if (!imageSlides.length) return;
          const items = imageSlides.map((slide) => {
            const zoom = slide.querySelector('[data-gallery-zoom]');
            const img = slide.querySelector('.wub-media-gallery__media img');
            const fallbackSrc = img?.currentSrc || img?.src || '';
            return {
              src: zoom?.getAttribute('href') || fallbackSrc,
              msrc: fallbackSrc,
              w: parseInt(zoom?.dataset.pswpWidth || img?.naturalWidth || img?.getAttribute('width') || 1200, 10),
              h: parseInt(zoom?.dataset.pswpHeight || img?.naturalHeight || img?.getAttribute('height') || 1200, 10)
            };
          });
          const currentIndex = imageSlides.findIndex((slide) => String(slide.dataset.mediaId) === String(currentSlide?.dataset.mediaId));
          const pswpElement = document.querySelector('.pswp');
          if (!pswpElement) return;
          const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            index: Math.max(0, currentIndex),
            maxSpreadZoom: 2,
            loop: false,
            allowPanToNext: false,
            closeOnScroll: false,
            showHideOpacity: false,
            arrowKeys: true,
            history: false,
            captionEl: false,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true
          });
          gallery.init();
        });
      });
    }

    activateByMediaId(mediaId, scrollThumb = true, userInitiated = false) {
      const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (index >= 0) this.goToIndex(index, scrollThumb, userInitiated);
    }

    goToIndex(index, scrollThumb = true, userInitiated = false) {
      if (!this.slides.length) return;
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.prewarmIndex(index, userInitiated ? 'high' : 'low');
      this.activeIndex = index;
      this.updateState(scrollThumb, userInitiated);

      if (this.isNativeSwipeMode()) {
        this.scrollViewportToIndex(index, userInitiated ? 'smooth' : 'auto');
      }

      const activeImage = this.slides[index]?.querySelector('.wub-media-gallery__media img');
      if (userInitiated || activeImage?.complete) this.prewarmAround(index);
    }

    updateState(scrollThumb = true, userInitiated = false) {
      const activeMediaId = String(this.slides[this.activeIndex]?.dataset.mediaId || '');
      const nativeSwipe = this.isNativeSwipeMode();

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.activeIndex;
        slide.classList.toggle('is-active', active);
        slide.hidden = nativeSwipe ? false : !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const zoom = slide.querySelector('[data-gallery-zoom]');
        if (zoom) {
          if (active) zoom.removeAttribute('tabindex');
          else zoom.setAttribute('tabindex', '-1');
        }
      });

      this.thumbs.forEach((button) => {
        const active = String(button.dataset.mediaId) === activeMediaId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          button.setAttribute('aria-current', 'true');
          if (scrollThumb && typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: userInitiated ? 'smooth' : 'auto' });
          }
        } else button.removeAttribute('aria-current');
      });

      this.bullets.forEach((button) => {
        const active = String(button.dataset.mediaId) === activeMediaId;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });

      if (this.prevButton) this.prevButton.disabled = this.activeIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex >= this.slides.length - 1;
    }

    scrollViewportToIndex(index, behavior = 'auto') {
      if (!this.viewport || !this.isNativeSwipeMode()) return;
      const width = this.viewport.clientWidth;
      if (!width) return;
      const left = index * width;
      if (Math.abs(this.viewport.scrollLeft - left) < 2) return;
      this.viewport.scrollTo({ left, top: 0, behavior });
    }

    queueNeighborPrewarm() {
      const activeImage = this.slides[this.activeIndex]?.querySelector('.wub-media-gallery__media img');
      const run = () => window.requestAnimationFrame(() => this.prewarmAround(this.activeIndex));
      if (!activeImage || activeImage.complete) run();
      else activeImage.addEventListener('load', run, { once: true });
    }

    prewarmAround(index) {
      this.prewarmIndex(index + 1, 'low');
      this.prewarmIndex(index - 1, 'low');
    }

    prewarmIndex(index, priority = 'low') {
      if (index < 0 || index >= this.slides.length) return;
      const image = this.slides[index]?.querySelector('.wub-media-gallery__media img');
      if (!image) return;

      if (image.loading === 'lazy') image.loading = 'eager';
      try {
        if (priority === 'high' || image.fetchPriority !== 'high') image.fetchPriority = priority;
      } catch (_) {}

      if (image.dataset.wubDecodeRequested === 'true' || typeof image.decode !== 'function') return;
      image.dataset.wubDecodeRequested = 'true';
      image.decode().catch(() => {});
    }
  }

  customElements.define('product-media-gallery-wub', ProductMediaGalleryWub);
}
